import { Text } from "theme-ui";
import displayFontWeightData from "../../../../documentation/data/text.yaml";
import * as React from 'react';
export default {
  Text,
  displayFontWeightData,
  React
};